import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Dark mode setup
const root = ReactDOM.createRoot(document.getElementById('root'));

// Check for saved dark mode preference
const savedDarkMode = localStorage.getItem('darkMode');
if (savedDarkMode === 'true') {
  document.body.classList.add('dark');
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);